import React, { useState } from 'react';
import AIProductMapModal from './AIProductMapModal';
import apiService from '../../services/api';
import { toast } from 'react-toastify';
import './CommonStyles.css';

const AIInvoiceReviewModal = ({ isOpen, onClose, uploadId, extractedData, matchedItems, onConfirmAndFill, setMatchedItems }) => {
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [currentMapIndex, setCurrentMapIndex] = useState(null);
  const [isApplying, setIsApplying] = useState(false);

  if (!isOpen || !extractedData) return null;

  const header = extractedData.header || {};
  const provider = extractedData.provider || 'tesseract';
  const overallConfidence = parseFloat(extractedData.overall_confidence || 0);

  const handleOpenMap = (index) => {
    setCurrentMapIndex(index);
    setMapModalOpen(true);
  };

  const handleMapConfirm = async (productData) => {
    if (currentMapIndex === null) return;
    const item = matchedItems[currentMapIndex];
    const itemId = item.db_item_id || 0;

    try {
      if (itemId) {
        await apiService.mapPurchaseInvoiceItem(
          uploadId,
          itemId,
          productData.value,
          productData.variation_id
        );
      }
      toast.success('Product mapped successfully.');
      
      const newItems = [...matchedItems];
      newItems[currentMapIndex] = {
        ...newItems[currentMapIndex],
        match_status: 'manual_mapped',
        product_name: productData.label,
        matched_product_id: productData.value,
        matched_variation_id: productData.variation_id
      };
      setMatchedItems(newItems);
      setMapModalOpen(false);
    } catch (err) {
      toast.error('Failed to map product.');
    }
  };

  const handleConfirm = () => {
    setIsApplying(true);
    onConfirmAndFill(extractedData, matchedItems);
    setIsApplying(false);
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 999999, backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-container" style={{ maxWidth: '900px', width: '95%', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        
        <div className="modal-header" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: '1.25rem', margin: 0, fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#3b82f6' }}>✨</span> Review AI Extracted Invoice Data
          </h2>
          <button className="close-btn" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b' }}>✕</button>
        </div>

        <div className="modal-body" style={{ padding: '1.5rem', overflowY: 'auto', flex: 1 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem', backgroundColor: '#f8fafc', padding: '1rem', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
            <div><strong style={{ color: '#475569' }}>Supplier:</strong> <div style={{ fontWeight: 500 }}>{header.supplier_name || '-'}</div></div>
            <div><strong style={{ color: '#475569' }}>Invoice #:</strong> <div style={{ fontWeight: 500 }}>{header.invoice_number || '-'}</div></div>
            <div><strong style={{ color: '#475569' }}>Date:</strong> <div style={{ fontWeight: 500 }}>{header.invoice_date || '-'}</div></div>
            <div><strong style={{ color: '#475569' }}>Total:</strong> <div style={{ fontWeight: 500 }}>{header.grand_total ? `$${parseFloat(header.grand_total).toFixed(2)}` : '-'}</div></div>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0' }}>
              <thead style={{ backgroundColor: '#f1f5f9' }}>
                <tr>
                  <th style={thStyle}>Product</th>
                  <th style={thStyle}>SKU</th>
                  <th style={thStyle}>Qty</th>
                  <th style={thStyle}>Unit Price</th>
                  <th style={thStyle}>GST%</th>
                  <th style={thStyle}>Total</th>
                  <th style={thStyle}>Match</th>
                  <th style={thStyle}>Action</th>
                </tr>
              </thead>
              <tbody>
                {matchedItems.map((row, i) => {
                  const ex = row.extracted || {};
                  const isMatched = row.match_status === 'matched' || row.match_status === 'manual_mapped';
                  
                  return (
                    <tr key={i} style={{ backgroundColor: isMatched ? 'transparent' : '#fef2f2', borderBottom: '1px solid #e2e8f0' }}>
                      <td style={tdStyle}>{ex.product_name || '-'}</td>
                      <td style={tdStyle}>{ex.sku || '-'}</td>
                      <td style={tdStyle}>{ex.quantity || '-'}</td>
                      <td style={tdStyle}>{ex.unit_price ? `$${parseFloat(ex.unit_price).toFixed(2)}` : '-'}</td>
                      <td style={tdStyle}>{ex.gst_percent ? `${ex.gst_percent}%` : '-'}</td>
                      <td style={tdStyle}>{ex.row_total ? `$${parseFloat(ex.row_total).toFixed(2)}` : '-'}</td>
                      <td style={tdStyle}>
                        {isMatched ? (
                          <span style={{ backgroundColor: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 600 }}>
                            {row.product_name || 'Matched'}
                          </span>
                        ) : (
                          <span style={{ backgroundColor: '#fee2e2', color: '#991b1b', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 600 }}>
                            Not Found
                          </span>
                        )}
                      </td>
                      <td style={tdStyle}>
                        <button
                          onClick={() => handleOpenMap(i)}
                          style={{
                            padding: '4px 8px',
                            fontSize: '0.75rem',
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}
                        >
                          🔗 Map
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {matchedItems.length === 0 && (
                  <tr>
                    <td colSpan="8" style={{ ...tdStyle, textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                      No items found in invoice.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#e0f2fe', border: '1px solid #bae6fd', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <span style={{ backgroundColor: provider === 'gemini' ? '#3b82f6' : '#64748b', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }}>
              {provider === 'gemini' ? 'AI (Gemini)' : 'OCR (Tesseract)'}
            </span>
            <span style={{ fontWeight: 600, color: '#0369a1' }}>
              Overall Confidence: {overallConfidence.toFixed(1)}%
            </span>
            <span style={{ color: '#0284c7', fontSize: '0.875rem' }}>
              — Please verify all values before saving.
            </span>
          </div>

        </div>

        <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '1rem 1.5rem', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', backgroundColor: '#f8fafc', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' }}>
          <button
            onClick={onClose}
            style={{ padding: '0.5rem 1rem', border: '1px solid #cbd5e1', backgroundColor: 'white', borderRadius: '6px', cursor: 'pointer', fontWeight: 500, color: '#475569' }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isApplying}
            style={{ padding: '0.5rem 1rem', border: 'none', backgroundColor: '#22c55e', color: 'white', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px', opacity: isApplying ? 0.7 : 1 }}
          >
            {isApplying ? 'Applying...' : '✓ Confirm & Fill Form'}
          </button>
        </div>
      </div>

      <AIProductMapModal
        isOpen={mapModalOpen}
        onClose={() => setMapModalOpen(false)}
        onConfirm={handleMapConfirm}
        currentItem={currentMapIndex !== null ? matchedItems[currentMapIndex] : null}
      />
    </div>
  );
};

const thStyle = {
  padding: '12px 16px',
  textAlign: 'left',
  borderBottom: '1px solid #e2e8f0',
  color: '#475569',
  fontWeight: 600,
  fontSize: '0.875rem'
};

const tdStyle = {
  padding: '12px 16px',
  borderBottom: '1px solid #e2e8f0',
  color: '#334155',
  fontSize: '0.875rem'
};

export default AIInvoiceReviewModal;
